import { Button, CircularProgress, Paper, TextField } from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';

import ErrorBoundary from '../../hoc/ErrorBoundary';
import { loginRequest } from '../../store/actions/auth';

import './Login.css';

class Login extends React.Component<any, any> {
  public state = {
    phone: '',
    password: '',
    isProcessing: false,
  };

  private loginTimeout: number | null;

  public onChange(inputName: 'phone' | 'password') {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({
        [inputName]: event.target.value,
      });
    };
  }

  public onSubmit() {
    return (event: React.FormEvent<any>) => {
      this.deactivateLogin();
      this.props.dispatch(loginRequest(this.state.phone, this.state.password));
      event.preventDefault();
    };
  }

  public componentWillUnmount() {
    if (this.loginTimeout) {
      window.clearTimeout(this.loginTimeout);
    }
  }

  public render() {
    return (
      <ErrorBoundary>
        <Paper className="Login">
          <form autoComplete="off" onSubmit={this.onSubmit()}>
            <TextField
              required={true}
              label="Phone"
              margin="normal"
              type="tel"
              onChange={this.onChange('phone')}
              value={this.state.phone}
            />
            <br />
            <TextField
              required={true}
              label="Password"
              type="password"
              autoComplete="current-password"
              margin="normal"
              onChange={this.onChange('password')}
              value={this.state.password}
            />
            <br />
            <Button variant="contained" type="submit" disabled={this.state.isProcessing}>
              Login
              {this.state.isProcessing ? <CircularProgress /> : null}
            </Button>
          </form>
        </Paper>
      </ErrorBoundary>
    );
  }

  private deactivateLogin() {
    this.loginTimeout = window.setTimeout(() => {
      this.setState({ isProcessing: false });
    }, 5000);
    this.setState({ isProcessing: true });
  }
}

export default connect()(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.tsx